import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface H6Props extends HTMLAttributes<HTMLHeadingElement> {}

const H6 = forwardRef<HTMLHeadingElement, H6Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <h6
        ref={ref}
        className={cn(
          'scroll-m-20 text-base font-semibold tracking-tight',
          className
        )}
        {...props}
      >
        {children}
      </h6>
    );
  }
);

H6.displayName = 'H6';

export { H6 };
